import React from "react";
import { useTranslation } from "react-i18next";
import { METRIC_ORDER } from "../../../utils/road";
import styles from "../../network_map/network_map.module.css";

const DAYS = [1, 7, 30];
const CELLS = [25, 50, 100, 250];

export default function RoadControls({
  open, onClose, metric, setMetric, days, setDays, cellM, setCellM, pdui, setPdui, devices,
  allSpeeds, setAllSpeeds, showChanges, setShowChanges, showImpacts, setShowImpacts, cellCount, windowCount,
}) {
  const { t } = useTranslation();
  return (
    <div className={`${styles.controls} ${open ? styles.controlsOpen : ""}`}>
      <div className={styles.controlsTitle}>
        {t("roadmap.title")}
        <button type="button" className={styles.closeButton} onClick={onClose}>×</button>
      </div>
      <div className={styles.group}>
        <div className={styles.groupLabel}>{t("roadmap.controls.metric")}</div>
        <div className={styles.chips}>
          {METRIC_ORDER.map((key) => (
            <button key={key} type="button" className={`${styles.chip} ${metric === key ? styles.chipActive : ""}`} onClick={() => setMetric(key)}>
              {t(`roadmap.metrics.${key}`)}
            </button>
          ))}
        </div>
      </div>
      <div className={styles.group}>
        <div className={styles.groupLabel}>{t("roadmap.controls.period")}</div>
        <div className={styles.chips}>
          {DAYS.map((d) => (
            <button key={d} type="button" className={`${styles.chip} ${days === d ? styles.chipActive : ""}`} onClick={() => setDays(d)}>
              {t(`roadmap.periods.d${d}`)}
            </button>
          ))}
        </div>
      </div>
      <div className={styles.group}>
        <div className={styles.groupLabel}>{t("roadmap.controls.cell")}</div>
        <div className={styles.chips}>
          {CELLS.map((c) => (
            <button key={c} type="button" className={`${styles.chip} ${cellM === c ? styles.chipActive : ""}`} onClick={() => setCellM(c)}>{c} m</button>
          ))}
        </div>
      </div>
      <div className={styles.group}>
        <div className={styles.groupLabel}>{t("roadmap.controls.truck")}</div>
        <select className={styles.select} value={pdui} onChange={(e) => setPdui(e.target.value)}>
          <option value="all">{t("roadmap.controls.allTrucks")}</option>
          {(devices || []).map((d) => (
            <option key={d.pdui_id} value={d.pdui_id}>{d.pdui_name}</option>
          ))}
        </select>
      </div>
      <div className={styles.group}>
        <label className={styles.checkRow}>
          <input type="checkbox" checked={!allSpeeds} onChange={(e) => setAllSpeeds(!e.target.checked)} />
          {t("roadmap.controls.movingOnly")}
        </label>
        <label className={styles.checkRow}>
          <input type="checkbox" checked={showChanges} onChange={(e) => setShowChanges(e.target.checked)} />
          {t("roadmap.controls.showChanges")}
        </label>
        <label className={styles.checkRow}>
          <input type="checkbox" checked={showImpacts} onChange={(e) => setShowImpacts(e.target.checked)} />
          {t("roadmap.controls.showImpacts")}
        </label>
      </div>
      <div className={styles.summary}>{t("roadmap.summary", { cells: cellCount, windows: windowCount })}</div>
    </div>
  );
}
